module.exports = __webpack_public_path__ + "static/Dial_rear-6f48a189b6788eaee89645a65887951b.jpg";